<template>
  <div
    :class="{
      'relative order-2 mb-10 flex w-full flex-col items-center justify-center border-t border-solid border-www-color-white pt-10 md:items-start md:justify-start lg:order-1 lg:mr-1/20 lg:block lg:w-[35%] lg:border-[0] lg:pt-0': true,
    }"
  >
    <PTCLink
      href="/en/"
      :class="{
        'mb-6 block h-52px max-w-189px': true,
      }"
    >
      <PtcPicture
        v-if="logo && logo.asset"
        provider="sanity"
        :src="logo.asset._ref"
        :img-attrs="{ class: { 'w-[11.8125rem]': true } }"
        :modifiers="{ w: 200 }"
        :alt="resolvedFooterLogo?.altText || 'PTC Logo'"
      />
    </PTCLink>
    <div
      :class="{
        'mb-10 text-sm leading-25.2px text-www-color-white': true,
      }"
    >
      <p>{{ address }}</p>
    </div>
    <!-- Application stores -->
    <div
      :class="{
        'mt-5 flex md:absolute md:right-0 md:top-10 md:gap-30px md:text-right lg:gap-0 lg:position-unset': true,
      }"
    >
      <PTCLink
        :href="androidAppStoreURL"
        :class="{
          'mr-9 last:mr-0 md:mr-2 md:max-w-24 lg:mr-6 lg:max-w-none': true,
        }"
        rel="noopener noreferrer"
        target="_blank"
      >
        <PtcPicture
          v-if="androidAppStoreLogo && androidAppStoreLogo.asset"
          provider="sanity"
          :img-attrs="{ class: { 'mb-4 h-[2rem] w-[6.75rem]': true } }"
          :modifiers="{ w: 108 }"
          alt="androidAppStoreLogo"
          :src="androidAppStoreLogo.asset._ref"
        />
      </PTCLink>
      <PTCLink
        :href="appleAppStoreURL"
        :class="{
          'mr-9 last:mr-0 md:mr-2 md:max-w-24 lg:mr-6 lg:max-w-none': true,
        }"
        rel="noopener noreferrer"
        target="_blank"
      >
        <PtcPicture
          v-if="appleAppStoreLogo && appleAppStoreLogo.asset"
          provider="sanity"
          :img-attrs="{ class: { 'mb-4 h-[32px] w-[6.75rem]': true } }"
          alt="appleAppStoreLogo"
          :src="appleAppStoreLogo.asset._ref"
        />
      </PTCLink>
    </div>

    <!-- Badges -->
    <div
      :class="{
        'badges mt-5 max-w-60 md:absolute md:right-0 md:top-[6.25rem] md:text-right lg:position-unset': true,
      }"
    >
      <PortableText
        v-if="badgeSection?.footerPortableText"
        :portable-data="badgeSection?.footerPortableText"
        :class="{
          'g-0': true,
        }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Footer } from '~/sanity/types';
const props = defineProps<Footer>();
const { getResolvedImage } = useRefsStore();
const resolvedFooterLogo = await getResolvedImage(props.logo?.asset?._ref);
</script>

<style>
.g-0 * {
  gap: 0 !important;
  padding: 0 !important;
}
@media (max-width: 1024px) {
  .badges .grid {
    flex-wrap: nowrap;
    display: flex !important;
    gap: 20px !important;
  }
}
</style>
